import { useFetchAiSettingsAccess } from 'ai-settings-ui-library/hooks/useFetchAiSettingsAccess';
import { useMemo } from 'react';

// TODO: useCached should be desired approach but we have old code that needs to be updated to avoid flikering on loading
export const useIsDisabledByAccessControls = (useCached = false) => {
  const {
    conversationDataEnabled,
    generativeAiEnabled,
    crmPropertiesEnabled,
    isAccessRequestLoading
  } = useFetchAiSettingsAccess();
  const isDisabledByAccessControls = useMemo(() => {
    if (useCached) {
      return !conversationDataEnabled || !generativeAiEnabled || !crmPropertiesEnabled;
    }
    return !isAccessRequestLoading && (!conversationDataEnabled || !generativeAiEnabled || !crmPropertiesEnabled);
  }, [conversationDataEnabled, generativeAiEnabled, crmPropertiesEnabled, isAccessRequestLoading, useCached]);
  return {
    isDisabledByAccessControls,
    isAccessRequestLoading
  };
};